import {
    CREATE_POINT_OF_INTEREST,
    CREATE_POINT_OF_INTEREST_FAILURE,

    CREATE_POINT_OF_INTEREST_IMPORT,
    CREATE_POINT_OF_INTEREST_IMPORT_FAILURE,

    CREATE_POINT_OF_INTEREST_LOCALISATION,
    CREATE_POINT_OF_INTEREST_LOCALISATION_FAILURE,
    CREATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const createPointOfInterest = (payload) => {
    return {
        type: CREATE_POINT_OF_INTEREST,
        payload: payload,
    };
};

export const createPointOfInterestFailure = (error) => {
    return {
        type: CREATE_POINT_OF_INTEREST_FAILURE,
        error: error,
    };
};

export const createPointOfInterestImport = (payload) => {
    return {
        type: CREATE_POINT_OF_INTEREST_IMPORT,
        payload: payload,
    };
};

export const createPointOfInterestImportFailure = (error) => {
    return {
        type: CREATE_POINT_OF_INTEREST_IMPORT_FAILURE,
        error: error,
    };
};

export const createPointOfInterestLocalisation = (payload, response) => {
    return {
        type: CREATE_POINT_OF_INTEREST_LOCALISATION,
        payload: payload,
        response: response,
    };
};

export const createPointOfInterestLocalisationFailure = (error) => {
    return {
        type: CREATE_POINT_OF_INTEREST_LOCALISATION_FAILURE,
        error: error,
    };
};

export const createPointOfInterestLocalisationSuccess = (payload, response) => {
    return {
        type: CREATE_POINT_OF_INTEREST_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/pointsofinterest/createPointsOfInterest.js